import * as riot from 'riot';

let mountedTags = [];
const TAG_PREFIX = 'ambita';

function getTags(selector: string): any[] {
  return mountedTags.filter((tag: any) => {
    if (selector.indexOf('#') === 0) {
      return tag.opts.id === selector.substr(1);
    } else {
      return tag.root.tagName.toLowerCase() === selector;
    }
  });
}

/**
 * Initializes a component(s) on the page
 * @public
 * @param tags a comma separated string of tag names
 * @param data
 */
export function mount(tags: string, data?) {
  const tagNames = tags.trim().toLowerCase().split(',');
  tagNames.forEach((tag) => {
    // mount only properly prefixed tags
    if (tag.indexOf(TAG_PREFIX) >= 0) {
      mountedTags = mountedTags.concat(riot.mount(tag.trim(), data));
    }
  });
}

/**
 * Deinitializes a component(s) on the page
 * @public
 * @param tags a comma separated string of tag names
 */
export function unmount(tags: string) {
  const tagNames = tags.trim().toLowerCase().split(',');
  tagNames.forEach((tagName) => {
    // unmount only prefixed tags
    if (tagName.indexOf(TAG_PREFIX) < 0) {
      return;
    }
    getTags(tagName.trim()).forEach((tag) => {
      tag.unmount();
      mountedTags.splice(mountedTags.indexOf(tag), 1);
    });
  });
}

/**
 * Updates a component(s) providing them with the config object
 * @public
 * @param tags a comma separated string of tag names
 * @param config an object with data for the specific component
 */
export function update(tags: string, config: Object) {
  getTags(tags).forEach((tag) => tag.externalUpdate && tag.externalUpdate(config));
}

/**
 * Mount tag on DOM elements matching specified selector.
 * DOM elements that already have mounted tag are ignored.
 * @public
 * @param selector String containing CSS selector
 * @param tagName Name of the tag that should be mounted on the selected elements
 * @param options Object with tag specific options
 */
export function mountSelector(selector: string, tagName: string, options?) {
  const domNodes = document.querySelectorAll(selector);
  Array.prototype.slice.call(domNodes).forEach(function (node) {
    if (node._tag && node._tag.isMounted) {
      return;
    }
    riot.mount(node, tagName, options);
  });
}

/**
 * Unmount tags from DOM elements matching specified selector.
 * DOM elements that have no mounted tag are ignored.
 * @public
 * @param selector String containing CSS selector
 * @param removeElement If true root DOM element will be removed after unmounting,
 * otherwise DOM element will be preserved
 */
export function unmountSelector(selector: string, removeElement?: boolean) {
  const domNodes = document.querySelectorAll(selector);
  Array.prototype.slice.call(domNodes).forEach(function (node) {
    if (node._tag && node._tag.isMounted) {
      node._tag.unmount(!removeElement);
    }
  });
}

/**
 * Updates a component(s) providing them with the config object
 * @public
 * @param selector String containing CSS selector for selecting mounted tags
 * @param options Object containing tag specific options
 */
export function updateSelector(selector: string, options) {
  const domNodes = document.querySelectorAll(selector);
  Array.prototype.slice.call(domNodes).forEach(function (node) {
    if (node._tag && node._tag.externalUpdate) {
      node._tag.externalUpdate(options);
    }
  });
}
